import { buildStateEvent, GenericStateEvent } from '../../common-redux'
import { Impact } from './model'

export interface ImpactStateEvent<T> extends GenericStateEvent<T> {}

export const GetAllImpactSuccessEvent = {
    type: 'GetAllImpactSuccessEvent',
    build: (payload: Impact[]) => buildStateEvent(GetAllImpactSuccessEvent.type, payload)
}
